export default __webpack_public_path__ + "2471538a04f90618ba60770d3365d9e8.jpeg";